export const listRoleName = state => {
  let temp = state.roleList
  let data = []
  let roles = ['superadmin', 'admin']

  temp.forEach(item => {
    if (!roles.includes(item.name))
      data.push({
        id: item.name,
        label: item.name
      })
  })

  return data
}

export const permissionList = state => {
  let temp = state.permissionList
  let android = []
  let cms = []

  temp.forEach(t => {
    if (t.group_id == 1) {
      cms.push(t.name)
    } else if (t.group_id == 2) {
      android.push(t.name)
    }
  })

  let data = {
    android: android,
    cms: cms
  }

  return data
}
